exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden {\n    display: none;\n}\n\n.ltInline ::ng-deep p {\n    display: inline;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/output/latex-table/latex-table.component.css
// module id = ./src/app/components/output/latex-table/latex-table.component.css
// module chunks = main